var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckbox = function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#A8B2A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1369 5.30982L7.99989 12.4468L4.80516 9.25211C4.39207 8.83902 3.72281 8.83902 3.30982 9.25211C2.89673 9.6652 2.89673 10.3345 3.30982 10.7475L7.25211 14.6897C7.45781 14.8954 7.72965 15 7.99977 15C8.2699 15 8.54002 14.8972 8.74742 14.6897L16.632 6.80516C17.0451 6.39207 17.0451 5.72281 16.632 5.30982C16.219 4.89673 15.5498 4.89673 15.1367 5.30982H15.1369Z",
    fill: "white"
  })));
};
export default SvgCheckbox;